import { render } from "./RefundManagement.vue?vue&type=template&id=3bbd7d80&scoped=true"
import script from "./RefundManagement.vue?vue&type=script&lang=js"
export * from "./RefundManagement.vue?vue&type=script&lang=js"

import "./RefundManagement.vue?vue&type=style&index=0&id=3bbd7d80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bbd7d80"]])

export default __exports__